import './SecondSection.scss'
import Benefit from './Benefit/Benefit'
import { HiOutlineIdentification } from 'react-icons/hi'
import { IoMdStarOutline } from 'react-icons/io'
import { MdOutlineVerified } from 'react-icons/md'
import { IoStorefrontOutline } from 'react-icons/io5'
import Section from '../Section'
import { useState } from 'react'

let props = {
  size: "65px",
  color: "#fff"
}
function getWindowSize() {
  const { innerWidth, innerHeight } = window;
  return { innerWidth, innerHeight };
}


const SecondSection = () => {
  const [windowSize] = useState(getWindowSize());

  if (windowSize.innerWidth <= 768) {
    props.size = '55px';
  }


  return (
    <div className="second-section" id="benefits">
      <Section title="Quais os benefícios de registrar sua marca?">

        <div className="second-section-benefit-container">
          <div className="second-section-benefits">
            <Benefit
              icon={<HiOutlineIdentification {...props} />}
              title="Segurança"
              desc="Garante a sua propriedade legal sob a marca"
            />

            <Benefit
              icon={<IoMdStarOutline {...props} />}
              title="Exclusividade"
              desc="Impede que terceiros copiem a sua marca"
            />

            <Benefit
              icon={<MdOutlineVerified {...props} />}
              title="Credibilidade"
              desc="Possibilita o uso do símbolo ®"
            />
            <Benefit
              icon={<IoStorefrontOutline {...props} />}
              title="Expansão"
              desc="Permite a abertura de franquias"
            />
          </div>

        </div>
      </Section>
    </div>

  )
}

export default SecondSection